import { PaymentOptionPropertiesInterface } from '../../../services/exports/Interfaces';
import PaymentMethodBrandIcons, { getCardBrandIcon } from './PaymentMethodBrandIcons';
import classnames from 'classnames';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import { useMemo } from 'react';
import { PaymentMethod } from '../../../services/exports/Constants';

interface Props extends Partial<PaymentOptionPropertiesInterface> {
  amount?: number;
  hideIcons?: boolean;
  classes?: {
    container?: string;
    icon?: string;
    text?: string;
  };
}

export default function PaymentDetails(props: Props) {
  const { payment_method_id, payment_method_brand, payment_method_details, amount, hideIcons, classes } = props;

  const { formatCurrency } = useAppMethods();
  const { findPaymentMethod } = usePaymentFlow();

  const hasBrandIcon = Boolean(getCardBrandIcon(payment_method_brand));
  const paymentMethod = findPaymentMethod(payment_method_id);
  const paymentMethodDetails = useMemo(() => {
    if (!payment_method_details) {
      return null;
    }

    return (
      {
        [PaymentMethod.Card]: `•••• ${payment_method_details}`,
        [PaymentMethod.ApplePay]: `•••• ${payment_method_details}`,
        [PaymentMethod.GooglePay]: `•••• ${payment_method_details}`,
        [PaymentMethod.Paypal]: payment_method_details,
      }[payment_method_id] ?? null
    );
  }, [payment_method_id, payment_method_details]);
  const hideName = payment_method_id === PaymentMethod.Paypal && Boolean(paymentMethodDetails);

  return (
    <div className={classnames('flex items-center text-sm min-w-0', classes?.container)}>
      {!hideIcons && (
        <PaymentMethodBrandIcons
          payment_method_id={payment_method_id}
          payment_method_brand={payment_method_brand}
          className={classes?.icon}
        />
      )}
      <p className={classnames('text-sm truncate', { 'ml-xs': !hideIcons }, classes?.text)}>
        {((!hasBrandIcon && Boolean(paymentMethod)) || hideIcons) && !hideName && `${paymentMethod.display_name} `}
        {Boolean(paymentMethodDetails) && ` ${paymentMethodDetails}`}
        {Boolean(amount) && ` - ${formatCurrency(amount)}`}
      </p>
    </div>
  );
}
